import { createSlice } from '@reduxjs/toolkit';
import { EProfitStatus, IPageState } from '../../types/page';
import { getMyHomesList, getMyHomeProfit } from '../../thunks';

const initialState: IPageState = {
  myHomeId: 0,
  myHomesList: [],
  profit: {
    data: null,
    status: EProfitStatus.init,
  },
  modals: {
    isOnboardingModalOpen: false,
    isRentModalOpen: false,
    isSaleModalOpen: false,
  },
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    openOnboardingModal(state, action) {
      state.modals.isOnboardingModalOpen = action.payload;
    },
    openRentModal(state, action) {
      state.modals.isRentModalOpen = action.payload;
    },
    openSaleModal(state, action) {
      state.modals.isSaleModalOpen = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getMyHomesList.fulfilled, (state, action) => {
        state.myHomesList = action.payload;
      })
      .addCase(getMyHomeProfit.pending, state => {
        state.profit.status = EProfitStatus.loading;
      })
      .addCase(getMyHomeProfit.fulfilled, (state, action) => {
        state.profit.status = EProfitStatus.succeed;
        state.profit.data = action.payload;
      })
      .addCase(getMyHomeProfit.rejected, state => {
        state.profit.status = EProfitStatus.failed;
      });
  },
});

export const {
  reducer: pageReducer,
  actions: { openOnboardingModal, openSaleModal, openRentModal },
} = pageSlice;
